import { CSSObject } from "@emotion/react";
import { overviewFontBuilderCss } from "../OverviewDataResults/OverviewDataResults.style";

export const pageHeaderTitleCss: CSSObject = {
  ...overviewFontBuilderCss({
    fontSize: "32px",
    fontStyle: "normal",
    fontWeight: "700",
    lineHeight: "125%",
  }),
  fontFamily: "Noto Serif",
};
